import { Callout, ExternalLink, Note } from "@octopusdeploy/design-system-components";
const AzureServiceFabricSdkRequiredInfo = (props: {}) => {
    return (<Callout type={"information"} title={"Service Fabric SDK install required"}>
            The <ExternalLink href="ServiceFabricSdkDownload">Service Fabric SDK</ExternalLink> must be installed on the <strong>Octopus Server</strong> for this step.{" "}
            <Note>
                {" "}
                Learn more about <ExternalLink href="ServiceFabricDeployingApps">Deploying to Service Fabric</ExternalLink>.
            </Note>
        </Callout>);
};
export default AzureServiceFabricSdkRequiredInfo;
